<div class="radios-container" [formGroup]="form">
  <p>43.{{ Texts.typeDate }}</p>
  <mat-radio-group
    aria-label="Select an option"
    formControlName="typeDate"
    (change)="onTypeDateChange()"
  >
    <div class="options">
      <mat-radio-button class="primary-radiobutton" value="date"
        >{{ Texts.date }}
      </mat-radio-button>
      <mat-radio-button class="primary-radiobutton" value="period"
        >Periodo
      </mat-radio-button>
    </div>
  </mat-radio-group>
  <div class="row">
    <ng-container *ngIf="isDate">
      <div class="col-6">
        <mat-form-field appearance="outline">
          <mat-label>Fecha</mat-label>
          <input matInput type="date" formControlName="date" />
        </mat-form-field>
      </div>
      <!-- <div class="col-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ Texts.operationRef }}</mat-label>
            <input matInput formControlName="operationRef" />
          </mat-form-field>
        </div> -->
    </ng-container>

    <ng-container *ngIf="isPeriod">
      <div class="col-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ Texts.from }}</mat-label>
          <input matInput type="date" formControlName="from" />
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field appearance="outline">
          <mat-label>{{ Texts.to }}</mat-label>
          <input matInput type="date" formControlName="to" />
        </mat-form-field>
      </div>
    </ng-container>
  </div>
</div>
